/* Recreate theme — minimal vanilla JS, no dependencies */
(function () {
  'use strict';

  /* ---------- Mobile drawer + search ------------------------------------ */

  function bindToggle(triggerSel, targetSel) {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(triggerSel);
      if (!trigger) return;
      var target = document.querySelector(targetSel);
      if (!target) return;
      e.preventDefault();
      if (target.hasAttribute('open')) {
        target.removeAttribute('open');
        document.body.style.overflow = '';
      } else {
        target.setAttribute('open', '');
        if (target.classList.contains('drawer')) document.body.style.overflow = 'hidden';
        var focusable = target.querySelector('input, a, button');
        if (focusable) focusable.focus();
      }
    });
  }

  bindToggle('[data-drawer-toggle]', '#nav-drawer');
  bindToggle('[data-search-toggle]', '#search-modal');

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) {
      var d = document.querySelector('#nav-drawer');
      if (d) d.removeAttribute('open');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.drawer[open], .search-modal[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
    document.body.style.overflow = '';
  });

  /* ---------- Quantity steppers ----------------------------------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product variant selection --------------------------------- */

  function initProductForm(root) {
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var mainImg = root.querySelector('[data-main-image]');
    var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var chosen = group.querySelector('[aria-checked="true"]');
          return chosen ? chosen.getAttribute('data-value') : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<span class="price__sale">' + formatMoney(match.price) + '</span> <s class="price__was">' + formatMoney(match.compare_at_price) + '</s>'
          : formatMoney(match.price);
      }

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (addBtn.getAttribute('data-add') || 'Add to cart')
          : (addBtn.getAttribute('data-soldout') || 'Sold out');
      }

      if (mainImg && match.featured_image) {
        mainImg.src = match.featured_image;
        mainImg.srcset = '';
      }

      if (history.replaceState && match.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var value = e.target.closest('[data-value]');
      if (!value) return;
      e.preventDefault();
      var group = value.closest('[data-option-index]');
      group.querySelectorAll('[data-value]').forEach(function (el) {
        el.setAttribute('aria-checked', el === value ? 'true' : 'false');
      });
      update();
    });

    update();
  }

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* ---------- Gallery thumbnails ---------------------------------------- */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    main.srcset = '';
    var opener = gallery.querySelector('[data-lightbox-open]');
    if (opener) opener.setAttribute('data-index', thumb.getAttribute('data-index') || '0');
  });

  /* ---------- Product image lightbox ------------------------------------ */

  (function () {
    var box = null;
    var images = [];
    var current = 0;
    var lastFocus = null;

    function imagesFor(gallery) {
      var el = gallery && gallery.querySelector('[data-gallery-images]');
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (err) { return []; }
    }

    function render() {
      var item = images[current];
      if (!item) return;
      var img = box.querySelector('.lightbox__img');
      img.src = item.full;
      img.alt = item.alt || '';
      img.classList.remove('is-zoomed');
      box.querySelector('[data-counter]').textContent = (current + 1) + ' / ' + images.length;
      box.querySelectorAll('.lightbox__thumb').forEach(function (t, i) {
        t.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function go(step) {
      if (images.length < 2) return;
      current = (current + step + images.length) % images.length;
      render();
    }

    function close() {
      if (!box) return;
      box.remove();
      box = null;
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    function open(gallery, index) {
      images = imagesFor(gallery);
      if (!images.length) return;
      current = Math.min(Math.max(index, 0), images.length - 1);
      lastFocus = document.activeElement;

      box = document.createElement('div');
      box.className = 'lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Product images');

      var thumbs = images.length > 1
        ? images.map(function (im, i) {
            return '<button class="lightbox__thumb" type="button" data-go="' + i +
                   '" aria-label="Image ' + (i + 1) + '"><img src="' + im.thumb + '" alt=""></button>';
          }).join('')
        : '';

      var arrows = images.length > 1
        ? '<button class="lightbox__nav lightbox__nav--prev" type="button" data-step="-1" aria-label="Previous image">' + ARROW + '</button>' +
          '<button class="lightbox__nav lightbox__nav--next" type="button" data-step="1" aria-label="Next image">' + ARROW + '</button>'
        : '';

      box.innerHTML =
        '<div class="lightbox__bar">' +
          '<span data-counter></span>' +
          '<button class="icon-btn" type="button" data-close aria-label="Close">' + CLOSE + '</button>' +
        '</div>' +
        '<div class="lightbox__stage">' + arrows + '<img class="lightbox__img" alt=""></div>' +
        '<div class="lightbox__thumbs">' + thumbs + '</div>';

      document.body.appendChild(box);
      document.body.style.overflow = 'hidden';
      render();
      box.querySelector('[data-close]').focus();

      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) return close();

        var step = e.target.closest('[data-step]');
        if (step) return go(parseInt(step.getAttribute('data-step'), 10));

        var jump = e.target.closest('[data-go]');
        if (jump) { current = parseInt(jump.getAttribute('data-go'), 10); return render(); }

        var img = e.target.closest('.lightbox__img');
        if (img) return img.classList.toggle('is-zoomed');

        // clicking the empty backdrop closes
        if (e.target.classList.contains('lightbox__stage') || e.target === box) close();
      });

      // swipe between images on touch
      var startX = null;
      box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 55) go(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-open]');
      if (!trigger) return;
      e.preventDefault();
      var gallery = trigger.closest('[data-gallery]');
      open(gallery, parseInt(trigger.getAttribute('data-index') || '0', 10));
    });

    document.addEventListener('keydown', function (e) {
      if (!box) return;
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    }, true);
  })();

  /* ---------- Delivery popup -------------------------------------------- */

  (function () {
    var popup = document.querySelector('[data-popup]');
    if (!popup) return;

    var key = popup.getAttribute('data-storage-key') || 'recreate-popup';
    var delay = parseInt(popup.getAttribute('data-delay') || '5000', 10);
    var lastFocus = null;

    function seen() {
      try { return localStorage.getItem(key) === '1'; } catch (err) { return false; }
    }

    function remember() {
      try { localStorage.setItem(key, '1'); } catch (err) { /* private mode — just don't persist */ }
    }

    function close() {
      popup.hidden = true;
      document.body.style.overflow = '';
      remember();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function show() {
      if (seen()) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var btn = popup.querySelector('.popup__close');
      if (btn) btn.focus();
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) {
        // let the CTA link navigate; everything else just dismisses
        if (!e.target.closest('a')) e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden && !document.querySelector('.lightbox')) close();
    });

    // don't fire inside the theme editor — it gets in the way while designing
    if (window.Shopify && window.Shopify.designMode) return;

    if (seen()) return;
    window.setTimeout(show, delay);
  })();

  /* ---------- Sort dropdown auto-submit ---------------------------------- */

  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------- Scroll reveal --------------------------------------------- */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Marquee: duplicate content for seamless loop -------------- */

  document.querySelectorAll('[data-marquee]').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });
})();
